import type {ComponentType} from 'react'
import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'
import {getBuild} from '../../../selectors'

import PersonalBuild from './BuildPersonal'
import type {OwnProps, StateProps} from './BuildPersonal.types'

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const {personal, user} = getBuild(state, props.buildId) || {}
  return {
    personal,
    userId: user?.id,
    user,
  }
}

export default connect(mapStateToProps, {})(PersonalBuild) as ComponentType<OwnProps>
